import { currencyTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    currency: {
        // select
        label: "Валюта",
        inputProps: { name: "currency" },
        options: currencyTypes,
        propName: "currency",
        required: true,
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
